import request from '@/middleware/request'

const getLookupTablesList = () => {
  return request({
    url: '/lookup_tables',
    method: 'get'
  })
}

const getLookupTables = (id, data) => {
  return request({
    url: `/lookup_tables/${id}`,
    method: 'post',
    data
  })
}

const createLookupTables = data => {
  return request({
    url: '/lookup_tables',
    method: 'post',
    data
  })
}

const updateLookupTables = (id, data) => {
  return request({
    url: `/lookup_tables/${id}`,
    method: 'patch',
    data
  })
}

const deleteLookupTables = id => {
  return request({
    url: `/lookup_tables/${id}`,
    method: 'delete'
  })
}

const clearLookupTable = id => {
  return request({
    url: `/lookup_tables/clear/${id}`,
    method: 'delete'
  })
}

const importLookupTables = (id, formData) => {
  return request({
    url: `/lookup_tables/import/csv/${id}`,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}

const exportLookupTables = id => {
  return request({
    url: `/lookup_tables/export/csv/${id}`,
    method: 'get',
    responseType: 'blob'
  })
}

const createDetails = (id, data) => {
  return request({
    url: `/lookup_tables/details/${id}`,
    method: 'post',
    data
  })
}

const updateDetails = (id, data) => {
  return request({
    url: `/lookup_tables/details/${id}`,
    method: 'patch',
    data
  })
}

const deleteDetails = (id, index) => {
  return request({
    url: `/lookup_tables/details/${id}/${index}`,
    method: 'delete'
  })
}

export default {
  getLookupTablesList,
  createLookupTables,
  updateLookupTables,
  deleteLookupTables,
  clearLookupTable,
  getLookupTables,
  importLookupTables,
  exportLookupTables,
  createDetails,
  updateDetails,
  deleteDetails
}
